import { IndexFormat } from "../../RenderEngine/RenderEnum/IndexFormat";
import { SpineMeshUtils } from "../mesh/SpineMeshUtils";
import { MultiRenderData } from "./MultiRenderData";
export class IBCreator {
    constructor() {
        this.ibLength = 0;
        this.maxIndexCount = 0;
    }
    updateFormat(vertexCount) {
        let ntype = SpineMeshUtils.getIndexFormat(vertexCount);
        if (this.type === ntype)
            return;
        this.type = ntype;
        this._updateBuffer();
    }
    setBufferLength(maxIndexCount) {
        if (maxIndexCount <= this.maxIndexCount)
            return;
        this.maxIndexCount = maxIndexCount;
        this._updateBuffer();
    }
    _updateBuffer() {
        let oldbuffer = this.ib;
        switch (this.type) {
            case IndexFormat.UInt16:
                this.size = 2;
                this.ib = new Uint16Array(this.maxIndexCount);
                break;
            case IndexFormat.UInt8:
                this.size = 1;
                this.ib = new Uint8Array(this.maxIndexCount);
                break;
            case IndexFormat.UInt32:
                this.size = 4;
                this.ib = new Uint32Array(this.maxIndexCount);
                break;
        }
        if (oldbuffer)
            this.ib.set(oldbuffer);
    }
    createIB(attachs, vbCreator, order) {
        let offset = 0;
        let slotVBMap = vbCreator.slotVBMap;
        let drawOrder;
        let getAttach;
        if (order) {
            drawOrder = order;
            getAttach = function (value) {
                return attachs[value];
            };
        }
        else {
            drawOrder = attachs;
            getAttach = function (value) {
                return value;
            };
        }
        let outRenderData = new MultiRenderData();
        let texture;
        let blend;
        let uploadData = [];
        let end = -1;
        for (let i = 0, n = drawOrder.length; i < n; i++) {
            let attach = getAttach(drawOrder[i]);
            if (attach.attachment && !attach.isPath) {
                let needAdd = false;
                if (texture != attach.textureName) {
                    texture = attach.textureName;
                    needAdd = true;
                }
                if (blend != attach.blendMode) {
                    blend = attach.blendMode;
                    needAdd = true;
                }
                if (needAdd) {
                    if (outRenderData.currentData) {
                        outRenderData.endData(offset);
                    }
                    outRenderData.addData(attach.textureName, attach.blendMode, offset, 0, attach.attachment);
                }
                let attachPos = slotVBMap.get(attach.slotId).get(attach.attachment);
                if (attach.attachment && attach.indexArray) {
                    uploadData.push({
                        data: attach.indexArray,
                        offset: attachPos.offset,
                        start: offset
                    });
                    offset += attach.indexArray.length;
                    end = Math.max(end, offset);
                }
            }
        }
        let vertexCount = vbCreator.maxVertexCount;
        let ntype = SpineMeshUtils.getIndexFormat(vertexCount);
        let needUpdateBuffer = false;
        if (ntype !== this.type) {
            this.type = ntype;
            needUpdateBuffer = true;
        }
        if (end > this.maxIndexCount) {
            this.maxIndexCount = end;
            needUpdateBuffer = true;
        }
        needUpdateBuffer && this._updateBuffer();
        let ib = this.ib;
        for (let i = 0, len = uploadData.length; i < len; i++) {
            let upload = uploadData[i];
            let offset = upload.offset;
            let start = upload.start;
            for (let j = 0, n = upload.data.length; j < n; j++) {
                ib[start + j] = upload.data[j] + offset;
            }
        }
        if (texture) {
            outRenderData.endData(offset);
        }
        this.outRenderData = outRenderData;
        this.ibLength = offset;
    }
}
